// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mn3NQ","col":"styles_col__3n9KW"};